module.exports = __webpack_public_path__ + "static/media/printer.2cd74f0a.jpg";